let showConfirmHandler = null;

/**
 * Registra el handler que mostrará el modal
 */
export function registerConfirmHandler(handler) {
    showConfirmHandler = handler;
}

/**
 * Llama al modal y devuelve una promesa que se resuelve con true/false
 * options: { message: string, okText?: string, cancelText?: string, okStyle?: object, cancelStyle?: object }
 */
export function confirmar(options) {
    if (!options || typeof options.message !== "string") {
        console.error("confirm: 'message' es obligatorio y debe ser un string");
    }

    return new Promise((resolve) => {
        if (showConfirmHandler) {
            showConfirmHandler(options, resolve);
        } else {
            console.error("No hay handler registrado para confirm");
            resolve(false);
        }
    });
}

